import { Button, Icon } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { FunktionsGrid } from 'components/profiles';
import { useRouter } from 'next/router';
import React from 'react';
import { PersonDto } from 'types/personen';
import { copyQuery, scrollToAnchor } from 'utils';
import { usePlusPage, useTranslation } from 'utils/hooks';

interface FunktionenProps 
{
  person: PersonDto;
}

const Funktionen: React.FC<FunktionenProps> = (props) =>
{
  const { person } = props;
  const { t } = useTranslation('profiles');
  const isPlusPage = usePlusPage();
  const router = useRouter();
  
  const renderFullscreenButton = (page: 'leitungsorgane' | 'kontrollorgane') => (
    <div style={{ margin: '0.5rem 0' }}>
      <Button
        variant="secondary"
        onClick={isPlusPage
          ? () => router.push({ pathname: router.pathname + '/' + page, query: copyQuery(router.query, ['id', 'token']) })
          : () => scrollToAnchor('plus-inhalte', -100)
        }
      >
        <Icon name={isPlusPage ? 'maximize' : 'lock'} />
        {t('profiles:actions.openFullscreen')}
      </Button> 
    </div>
  );
  
  return (
    <>

      {/* Leitungsorgan */}
      {!!person.leitungsorgane && (
        <ContentRow
          id="funktionen"
          title={t('profiles:personen.leitungsorgane.label')}
          actionRenderer={() => renderFullscreenButton('leitungsorgane')}
          groupItem
        >
          
          {/* <Show when={person.isCoKgGeschäftsführer}>
            <Disclaimer text={t('profiles:personen.leitungsorgane.disclaimer')} />
            <Spacer height={1} />
          </Show> */}
          
          <FunktionsGrid data={person.leitungsorgane} />

        </ContentRow>
      )}

      {/* Kontrollorgan */}
      {!!person.kontrollorgane && (
        <ContentRow
          id="kontrollorgan"
          title={t('profiles:personen.kontrollorgane.label')}
          actionRenderer={() => renderFullscreenButton('kontrollorgane')}
          groupItem
        >
          <FunktionsGrid data={person.kontrollorgane} />
        </ContentRow>
      )}

    </>
  );
};

export default Funktionen;
